import React from 'react';
import ContactHero from '../components/contact/ContactHero';
import ContactDetailsSection from '../components/contact/ContactDetailsSection';
import Seo from '../components/seo/Seo';

const Contact: React.FC = () => {
  return (
    <main className="bg-black text-white pt-20">
      <Seo
        title="Contact Hogar Dorado House"
        description="Contact Hogar Dorado House to discuss Dubai and USA real estate investments, Golden Visa services, and tailored property advisory."
        pathname="/contact"
        keywords={[
          'contact Hogar Dorado',
          'contact real estate advisor',
          'Dubai property contact',
          'USA property contact',
          'America real estate contact',
          'WhatsApp Dubai real estate',
          'inquire about Dubai properties',
          'inquire about USA properties'
        ]}
      />
      <ContactHero />
      <ContactDetailsSection />
    </main>
  );
};

export default Contact;